const React = require('react');

const Content = require('../common/Content.jsx');
const Meta = require('../invoice/Meta.jsx');
const Token = require('../utility/Token.jsx');
const Utilities = require('../utility/Utilities.jsx');

// #region CONTACT COMPANY

function ContactCompany(props) {
    const data = props.data || {};
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={Utilities.isNullOrWhitespace(data.BilledToCompany)} value={data.BilledToCompany} />;
}
const TypeConfigContactCompany = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ value: 'inline' }),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {}, {})
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion CONTACT COMPANY

// #region CONTACT NAME

function ContactName(props) {
    const data = props.data || {};
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={Utilities.isNullOrWhitespace(data.BilledToName)} value={data.BilledToName} />;
}
const TypeConfigContactName = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ value: 'inline' }),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, { value: 'Prepared For: ' }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {}, {})
                ]
            }
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion CONTACT NAME

// #region VALID THROUGH

function ValidThrough(props) {
    const data = props.data || {};
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={Utilities.isNullOrWhitespace(data.ValidThrough)} value={data.ValidThrough} />;
}
const TypeConfigValidThrough = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType({ value: 'inline' }),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, { value: 'Valid Through: ' }, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, {}, {})
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

// #endregion VALID THROUGH

// #region VALID THROUGH V2

function _ValidThroughV2(props) {
    const data = props.data || {};
    if (!props.builder && Utilities.isNullOrWhitespace(data.ValidThrough)) {
        return null;
    }
    return <Content.LabelValue {...props} formatValue={false} value={props.content} />;
}
const ValidThroughV2 = Content.withLabelTokenParsing(_ValidThroughV2, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Date:
            if (!Utilities.isNullOrWhitespace(data.ValidThrough)) {
                replaceString = data.ValidThrough;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const TokensValidThrough = () => [{ display: 'Valid Through', token: Token.Date }];
const TypeConfigValidThroughV2 = {
    panel: {
        block: Content.TypeConfig.labelValue.panelV2.block,
        description: Content.TypeConfig.labelValue.panelV2.description,
        label: () => Content.TypeConfig.labelValue.panelV2.label(Utilities.wrapTextForEditor({ text: 'Valid Through:' })),
        style: Content.TypeConfig.labelValue.panelV2.style,
        value: () => Content.TypeConfig.labelValue.panelV2.value(Utilities.wrapTextForEditor({ text: `{${Token.Date}}`, token: Token.Date }))
    }
};

// #endregion VALID THROUGH V2

const TypeConfigInvoiceDate = {
    panel: {
        block: function () { return Meta.InvoiceDate.TypeConfig.panel.block({ value: 'Date: ' }); },
        style: Meta.InvoiceDate.TypeConfig.panel.style
    }
};
const TypeConfigStaff = {
    panel: {
        block: function () { return Meta.Staff.TypeConfig.panel.block({ value: 'Prepared By: ' }); },
        style: Meta.Staff.TypeConfig.panel.style,
        visibility: Meta.Staff.TypeConfig.panel.visibility
    }
};

module.exports = {
    ContactCompany: {
        Component: ContactCompany,
        TypeConfig: TypeConfigContactCompany
    },
    ContactName: {
        Component: ContactName,
        TypeConfig: TypeConfigContactName
    },
    Date: {
        Component: Meta.InvoiceDate.Component,
        TypeConfig: TypeConfigInvoiceDate
    },
    Staff: {
        Component: Meta.Staff.Component,
        TypeConfig: TypeConfigStaff
    },
    ValidThrough: {
        Component: ValidThrough,
        TypeConfig: TypeConfigValidThrough
    },

    V2: {
        ...Meta.V2,
        ValidThrough: {
            Component: ValidThroughV2,
            Tokens: TokensValidThrough,
            TypeConfig: TypeConfigValidThroughV2
        }
    }
};